// Flattens the visible Brand → Collection → (Material) → Color hierarchy into gallery entries.
export const flattenFabrics = (brands = []) => {
  const entries = [];
  brands.forEach((brand) => {
    (brand.collections || []).forEach((collection) => {
      const base = {
        brand_id: brand.id,
        brand_name: brand.name,
        brand_website: brand.website,
        collection_id: collection.id,
        collection_name: collection.name,
        collection_website_url: collection.website_url,
        fabric_type: collection.fabric_type,
        openness: collection.openness,
        composition: collection.composition,
        widths: collection.widths,
      };
      if (collection.materials?.length) {
        collection.materials.forEach((material) => {
          (material.colors || []).forEach((color) => {
            entries.push({ ...base, ...color, key: `${collection.id}:${material.id}:${color.id}`, material_id: material.id, material_name: material.name, composition: material.composition || base.composition, stock_status: color.stock_status || material.stock_status || collection.stock_status || null, discontinued: !!(color.discontinued || material.discontinued || collection.discontinued) });
          });
        });
      } else {
        (collection.colors || []).forEach((color) => {
          entries.push({ ...base, ...color, key: `${collection.id}::${color.id}`, material_id: null, material_name: null, stock_status: color.stock_status || collection.stock_status || null, discontinued: !!(color.discontinued || collection.discontinued) });
        });
      }
    });
  });
  return entries;
};

export const uniqueValues = (entries, key) => [...new Set(entries.map((e) => e[key]).filter(Boolean))].sort();
